export default __webpack_public_path__ + "static/media/green-felt.598cfa26.webp";